// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Rect$SmartcutsMacros = require("./Rect.bs.js");
var Image$SmartcutsMacros = require("./Image.bs.js");
var Selector$SmartcutsMacros = require("./Selector.bs.js");
var DOM__Event$SmartcutsMacros = require("./DOM__Event.bs.js");
var Screenshot$SmartcutsMacros = require("./Screenshot.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var PromisedValue$SmartcutsMacros = require("./PromisedValue.bs.js");
var Storage__Images$SmartcutsMacros = require("./Storage__Images.bs.js");
var CommandPreconditions$SmartcutsMacros = require("./CommandPreconditions.bs.js");
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = require("./InterfaceBtwnRecordingAndPlayback.bs.js");

function t_encode(v) {
  if (v.TAG === /* FromContentScript */0) {
    return [
            "FromContentScript",
            Decco.floatToJson(v._0)
          ];
  } else {
    return [
            "FromBgScript",
            Decco.floatToJson(v._0)
          ];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "FromBgScript" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FromBgScript */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "FromContentScript" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FromContentScript */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function toFloat(v) {
  return v._0;
}

var ContextDependentDevicePixelRatio = {
  t_encode: t_encode,
  t_decode: t_decode,
  toFloat: toFloat
};

function windowGeometry_encode(v) {
  return Js_dict.fromArray([
              [
                "width",
                Decco.intToJson(v.width)
              ],
              [
                "height",
                Decco.intToJson(v.height)
              ],
              [
                "zoomFactor",
                Decco.floatToJson(v.zoomFactor)
              ],
              [
                "devicePixelRatio",
                t_encode(v.devicePixelRatio)
              ]
            ]);
}

function windowGeometry_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var width = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "width"), null));
  if (width.TAG === /* Ok */0) {
    var height = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "height"), null));
    if (height.TAG === /* Ok */0) {
      var zoomFactor = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "zoomFactor"), null));
      if (zoomFactor.TAG === /* Ok */0) {
        var devicePixelRatio = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "devicePixelRatio"), null));
        if (devicePixelRatio.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    width: width._0,
                    height: height._0,
                    zoomFactor: zoomFactor._0,
                    devicePixelRatio: devicePixelRatio._0
                  }
                };
        }
        var e = devicePixelRatio._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".devicePixelRatio" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = zoomFactor._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".zoomFactor" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = height._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".height" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = width._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".width" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function frame_encode(v) {
  if (v.TAG === /* TopFrame */0) {
    return [
            "TopFrame",
            Decco.stringToJson(v._0)
          ];
  } else {
    return [
            "Frame",
            Decco.intToJson(v._0),
            Decco.stringToJson(v._1),
            Decco.intToJson(v._2)
          ];
  }
}

function frame_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Frame" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          var match$3 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 3));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              if (match$3.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* Frame */1,
                          _0: match$1._0,
                          _1: match$2._0,
                          _2: match$3._0
                        }
                      };
              }
              var e = match$3._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "TopFrame" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TopFrame */0,
                      _0: v0._0
                    }
                  };
          }
          var e$3 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function focusStatus_encode(v) {
  if (v) {
    return ["NotFocused"];
  } else {
    return ["Focused"];
  }
}

function focusStatus_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Focused" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Focused */0
                  };
          }
      case "NotFocused" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotFocused */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyFocusStatus(focusState) {
  if (focusState) {
    return "NotFocused";
  } else {
    return "Focused";
  }
}

function commandContextLocal_encode(v) {
  return Js_dict.fromArray([
              [
                "frame",
                frame_encode(v.frame)
              ],
              [
                "windowGeometry",
                windowGeometry_encode(v.windowGeometry)
              ],
              [
                "targetBoundingRect",
                Decco.optionToJson(Rect$SmartcutsMacros.t_encode, v.targetBoundingRect)
              ],
              [
                "timestamp",
                Decco.floatToJson(v.timestamp)
              ],
              [
                "htmlSnapshot",
                Decco.stringToJson(v.htmlSnapshot)
              ],
              [
                "preconditions",
                Decco.optionToJson(CommandPreconditions$SmartcutsMacros.t_encode, v.preconditions)
              ],
              [
                "maybeLogoutLocator",
                Decco.optionToJson(Selector$SmartcutsMacros.elementSelector_encode, v.maybeLogoutLocator)
              ]
            ]);
}

function commandContextLocal_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var frame = frame_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "frame"), null));
  if (frame.TAG === /* Ok */0) {
    var windowGeometry = windowGeometry_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowGeometry"), null));
    if (windowGeometry.TAG === /* Ok */0) {
      var targetBoundingRect = Decco.optionFromJson(Rect$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetBoundingRect"), null));
      if (targetBoundingRect.TAG === /* Ok */0) {
        var timestamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timestamp"), null));
        if (timestamp.TAG === /* Ok */0) {
          var htmlSnapshot = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlSnapshot"), null));
          if (htmlSnapshot.TAG === /* Ok */0) {
            var preconditions = Decco.optionFromJson(CommandPreconditions$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "preconditions"), null));
            if (preconditions.TAG === /* Ok */0) {
              var maybeLogoutLocator = Decco.optionFromJson(Selector$SmartcutsMacros.elementSelector_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeLogoutLocator"), null));
              if (maybeLogoutLocator.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          frame: frame._0,
                          windowGeometry: windowGeometry._0,
                          targetBoundingRect: targetBoundingRect._0,
                          timestamp: timestamp._0,
                          htmlSnapshot: htmlSnapshot._0,
                          preconditions: preconditions._0,
                          maybeLogoutLocator: maybeLogoutLocator._0
                        }
                      };
              }
              var e = maybeLogoutLocator._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".maybeLogoutLocator" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = preconditions._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".preconditions" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = htmlSnapshot._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".htmlSnapshot" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = timestamp._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".timestamp" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = targetBoundingRect._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".targetBoundingRect" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = windowGeometry._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".windowGeometry" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = frame._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".frame" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

var associatedElementBoundingRectFromTargetDomEvent = DOM__Event$SmartcutsMacros.boundingClientRectGet;

function targetBoundingRectFromDomElement(element) {
  return Rect$SmartcutsMacros.fromDomRect(element.getBoundingClientRect());
}

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "windowRef",
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_encode(v.windowRef)
              ],
              [
                "tabRef",
                PromisedValue$SmartcutsMacros.t_encode(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_encode, v.tabRef)
              ],
              [
                "url",
                PromisedValue$SmartcutsMacros.t_encode(Decco.stringToJson, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_encode, v.url)
              ],
              [
                "focusStatus",
                focusStatus_encode(v.focusStatus)
              ],
              [
                "title",
                PromisedValue$SmartcutsMacros.t_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_encode, v.title)
              ],
              [
                "frame",
                PromisedValue$SmartcutsMacros.t_encode(frame_encode, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_encode, v.frame)
              ],
              [
                "windowGeometry",
                PromisedValue$SmartcutsMacros.t_encode(windowGeometry_encode, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_encode, v.windowGeometry)
              ],
              [
                "targetBoundingRect",
                Decco.optionToJson(Rect$SmartcutsMacros.t_encode, v.targetBoundingRect)
              ],
              [
                "timestamp",
                Decco.floatToJson(v.timestamp)
              ],
              [
                "htmlSnapshot",
                Decco.stringToJson(v.htmlSnapshot)
              ],
              [
                "screenshot",
                PromisedValue$SmartcutsMacros.t_encode(Screenshot$SmartcutsMacros.t_encode, Image$SmartcutsMacros.id_encode, v.screenshot)
              ],
              [
                "croppedScreenshot",
                Screenshot$SmartcutsMacros.t_encode(v.croppedScreenshot)
              ],
              [
                "preconditions",
                Decco.optionToJson(CommandPreconditions$SmartcutsMacros.t_encode, v.preconditions)
              ],
              [
                "maybeLogoutLocator",
                Decco.optionToJson(Selector$SmartcutsMacros.elementSelector_encode, v.maybeLogoutLocator)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var windowRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowRef"), null));
  if (windowRef.TAG === /* Ok */0) {
    var tabRef = PromisedValue$SmartcutsMacros.t_decode(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabRef"), null));
    if (tabRef.TAG === /* Ok */0) {
      var url = PromisedValue$SmartcutsMacros.t_decode(Decco.stringFromJson, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
      if (url.TAG === /* Ok */0) {
        var focusStatus = focusStatus_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "focusStatus"), null));
        if (focusStatus.TAG === /* Ok */0) {
          var title = PromisedValue$SmartcutsMacros.t_decode((function (param) {
                  return Decco.optionFromJson(Decco.stringFromJson, param);
                }), PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
          if (title.TAG === /* Ok */0) {
            var frame = PromisedValue$SmartcutsMacros.t_decode(frame_decode, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "frame"), null));
            if (frame.TAG === /* Ok */0) {
              var windowGeometry = PromisedValue$SmartcutsMacros.t_decode(windowGeometry_decode, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowGeometry"), null));
              if (windowGeometry.TAG === /* Ok */0) {
                var targetBoundingRect = Decco.optionFromJson(Rect$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetBoundingRect"), null));
                if (targetBoundingRect.TAG === /* Ok */0) {
                  var timestamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timestamp"), null));
                  if (timestamp.TAG === /* Ok */0) {
                    var htmlSnapshot = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlSnapshot"), null));
                    if (htmlSnapshot.TAG === /* Ok */0) {
                      var screenshot = PromisedValue$SmartcutsMacros.t_decode(Screenshot$SmartcutsMacros.t_decode, Image$SmartcutsMacros.id_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenshot"), null));
                      if (screenshot.TAG === /* Ok */0) {
                        var croppedScreenshot = Screenshot$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "croppedScreenshot"), null));
                        if (croppedScreenshot.TAG === /* Ok */0) {
                          var preconditions = Decco.optionFromJson(CommandPreconditions$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "preconditions"), null));
                          if (preconditions.TAG === /* Ok */0) {
                            var maybeLogoutLocator = Decco.optionFromJson(Selector$SmartcutsMacros.elementSelector_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeLogoutLocator"), null));
                            if (maybeLogoutLocator.TAG === /* Ok */0) {
                              return {
                                      TAG: /* Ok */0,
                                      _0: {
                                        windowRef: windowRef._0,
                                        tabRef: tabRef._0,
                                        url: url._0,
                                        focusStatus: focusStatus._0,
                                        title: title._0,
                                        frame: frame._0,
                                        windowGeometry: windowGeometry._0,
                                        targetBoundingRect: targetBoundingRect._0,
                                        timestamp: timestamp._0,
                                        htmlSnapshot: htmlSnapshot._0,
                                        screenshot: screenshot._0,
                                        croppedScreenshot: croppedScreenshot._0,
                                        preconditions: preconditions._0,
                                        maybeLogoutLocator: maybeLogoutLocator._0
                                      }
                                    };
                            }
                            var e = maybeLogoutLocator._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".maybeLogoutLocator" + e.path,
                                      message: e.message,
                                      value: e.value
                                    }
                                  };
                          }
                          var e$1 = preconditions._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".preconditions" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                  }
                                };
                        }
                        var e$2 = croppedScreenshot._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".croppedScreenshot" + e$2.path,
                                  message: e$2.message,
                                  value: e$2.value
                                }
                              };
                      }
                      var e$3 = screenshot._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".screenshot" + e$3.path,
                                message: e$3.message,
                                value: e$3.value
                              }
                            };
                    }
                    var e$4 = htmlSnapshot._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".htmlSnapshot" + e$4.path,
                              message: e$4.message,
                              value: e$4.value
                            }
                          };
                  }
                  var e$5 = timestamp._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".timestamp" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                          }
                        };
                }
                var e$6 = targetBoundingRect._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".targetBoundingRect" + e$6.path,
                          message: e$6.message,
                          value: e$6.value
                        }
                      };
              }
              var e$7 = windowGeometry._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".windowGeometry" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                      }
                    };
            }
            var e$8 = frame._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".frame" + e$8.path,
                      message: e$8.message,
                      value: e$8.value
                    }
                  };
          }
          var e$9 = title._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".title" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
        }
        var e$10 = focusStatus._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".focusStatus" + e$10.path,
                  message: e$10.message,
                  value: e$10.value
                }
              };
      }
      var e$11 = url._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".url" + e$11.path,
                message: e$11.message,
                value: e$11.value
              }
            };
    }
    var e$12 = tabRef._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".tabRef" + e$12.path,
              message: e$12.message,
              value: e$12.value
            }
          };
  }
  var e$13 = windowRef._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".windowRef" + e$13.path,
            message: e$13.message,
            value: e$13.value
          }
        };
}

function minify(context) {
  var screenshot = context.screenshot;
  var tmp;
  tmp = screenshot.TAG === /* Resolved */0 ? ({
        TAG: /* Resolved */0,
        _0: Screenshot$SmartcutsMacros.minify(screenshot._0)
      }) : screenshot;
  return {
          windowRef: context.windowRef,
          tabRef: context.tabRef,
          url: context.url,
          focusStatus: context.focusStatus,
          title: context.title,
          frame: context.frame,
          windowGeometry: context.windowGeometry,
          targetBoundingRect: context.targetBoundingRect,
          timestamp: context.timestamp,
          htmlSnapshot: context.htmlSnapshot,
          screenshot: tmp,
          croppedScreenshot: Screenshot$SmartcutsMacros.minify(context.croppedScreenshot),
          preconditions: context.preconditions,
          maybeLogoutLocator: context.maybeLogoutLocator
        };
}

function getMaybeDevicePixelRatio(param) {
  var windowGeometry = param.windowGeometry;
  if (windowGeometry.TAG === /* Resolved */0) {
    return windowGeometry._0.devicePixelRatio._0;
  }
  
}

var CommandContextGlobalPromised = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  minify: minify,
  getMaybeDevicePixelRatio: getMaybeDevicePixelRatio
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "windowRef",
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_encode(v.windowRef)
              ],
              [
                "tabRef",
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v.tabRef)
              ],
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "focusStatus",
                focusStatus_encode(v.focusStatus)
              ],
              [
                "title",
                Decco.optionToJson(Decco.stringToJson, v.title)
              ],
              [
                "frame",
                frame_encode(v.frame)
              ],
              [
                "windowGeometry",
                windowGeometry_encode(v.windowGeometry)
              ],
              [
                "targetBoundingRect",
                Decco.optionToJson(Rect$SmartcutsMacros.t_encode, v.targetBoundingRect)
              ],
              [
                "timestamp",
                Decco.floatToJson(v.timestamp)
              ],
              [
                "htmlSnapshot",
                Decco.stringToJson(v.htmlSnapshot)
              ],
              [
                "screenshot",
                Screenshot$SmartcutsMacros.t_encode(v.screenshot)
              ],
              [
                "croppedScreenshot",
                Screenshot$SmartcutsMacros.t_encode(v.croppedScreenshot)
              ],
              [
                "preconditions",
                Decco.optionToJson(CommandPreconditions$SmartcutsMacros.t_encode, v.preconditions)
              ],
              [
                "maybeLogoutLocator",
                Decco.optionToJson(Selector$SmartcutsMacros.elementSelector_encode, v.maybeLogoutLocator)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var windowRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowRef"), null));
  if (windowRef.TAG === /* Ok */0) {
    var tabRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabRef"), null));
    if (tabRef.TAG === /* Ok */0) {
      var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
      if (url.TAG === /* Ok */0) {
        var focusStatus = focusStatus_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "focusStatus"), null));
        if (focusStatus.TAG === /* Ok */0) {
          var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
          if (title.TAG === /* Ok */0) {
            var frame = frame_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "frame"), null));
            if (frame.TAG === /* Ok */0) {
              var windowGeometry = windowGeometry_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowGeometry"), null));
              if (windowGeometry.TAG === /* Ok */0) {
                var targetBoundingRect = Decco.optionFromJson(Rect$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetBoundingRect"), null));
                if (targetBoundingRect.TAG === /* Ok */0) {
                  var timestamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timestamp"), null));
                  if (timestamp.TAG === /* Ok */0) {
                    var htmlSnapshot = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlSnapshot"), null));
                    if (htmlSnapshot.TAG === /* Ok */0) {
                      var screenshot = Screenshot$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenshot"), null));
                      if (screenshot.TAG === /* Ok */0) {
                        var croppedScreenshot = Screenshot$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "croppedScreenshot"), null));
                        if (croppedScreenshot.TAG === /* Ok */0) {
                          var preconditions = Decco.optionFromJson(CommandPreconditions$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "preconditions"), null));
                          if (preconditions.TAG === /* Ok */0) {
                            var maybeLogoutLocator = Decco.optionFromJson(Selector$SmartcutsMacros.elementSelector_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeLogoutLocator"), null));
                            if (maybeLogoutLocator.TAG === /* Ok */0) {
                              return {
                                      TAG: /* Ok */0,
                                      _0: {
                                        windowRef: windowRef._0,
                                        tabRef: tabRef._0,
                                        url: url._0,
                                        focusStatus: focusStatus._0,
                                        title: title._0,
                                        frame: frame._0,
                                        windowGeometry: windowGeometry._0,
                                        targetBoundingRect: targetBoundingRect._0,
                                        timestamp: timestamp._0,
                                        htmlSnapshot: htmlSnapshot._0,
                                        screenshot: screenshot._0,
                                        croppedScreenshot: croppedScreenshot._0,
                                        preconditions: preconditions._0,
                                        maybeLogoutLocator: maybeLogoutLocator._0
                                      }
                                    };
                            }
                            var e = maybeLogoutLocator._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".maybeLogoutLocator" + e.path,
                                      message: e.message,
                                      value: e.value
                                    }
                                  };
                          }
                          var e$1 = preconditions._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".preconditions" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                  }
                                };
                        }
                        var e$2 = croppedScreenshot._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".croppedScreenshot" + e$2.path,
                                  message: e$2.message,
                                  value: e$2.value
                                }
                              };
                      }
                      var e$3 = screenshot._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".screenshot" + e$3.path,
                                message: e$3.message,
                                value: e$3.value
                              }
                            };
                    }
                    var e$4 = htmlSnapshot._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".htmlSnapshot" + e$4.path,
                              message: e$4.message,
                              value: e$4.value
                            }
                          };
                  }
                  var e$5 = timestamp._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".timestamp" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                          }
                        };
                }
                var e$6 = targetBoundingRect._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".targetBoundingRect" + e$6.path,
                          message: e$6.message,
                          value: e$6.value
                        }
                      };
              }
              var e$7 = windowGeometry._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".windowGeometry" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                      }
                    };
            }
            var e$8 = frame._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".frame" + e$8.path,
                      message: e$8.message,
                      value: e$8.value
                    }
                  };
          }
          var e$9 = title._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".title" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
        }
        var e$10 = focusStatus._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".focusStatus" + e$10.path,
                  message: e$10.message,
                  value: e$10.value
                }
              };
      }
      var e$11 = url._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".url" + e$11.path,
                message: e$11.message,
                value: e$11.value
              }
            };
    }
    var e$12 = tabRef._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".tabRef" + e$12.path,
              message: e$12.message,
              value: e$12.value
            }
          };
  }
  var e$13 = windowRef._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".windowRef" + e$13.path,
            message: e$13.message,
            value: e$13.value
          }
        };
}

function stringify(v) {
  return JSON.stringify(t_encode$2(v));
}

function fromCommandContextGlobalPromised(param) {
  var screenshot = param.screenshot;
  var tmp;
  tmp = screenshot.TAG === /* Resolved */0 ? screenshot._0 : /* NoImage */0;
  return {
          windowRef: param.windowRef,
          tabRef: PromisedValue$SmartcutsMacros.getResolvedExn((function (pendingPlaceholder) {
                  return "for tabRef w/placeholder" + PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.stringify(pendingPlaceholder);
                }), param.tabRef),
          url: PromisedValue$SmartcutsMacros.getResolvedExn((function (pendingPlaceholder) {
                  return "for url w/placeholder" + PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.stringify(pendingPlaceholder);
                }), param.url),
          focusStatus: param.focusStatus,
          title: PromisedValue$SmartcutsMacros.getResolvedExn((function (pendingPlaceholder) {
                  return "for title w/placeholder" + PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.stringify(pendingPlaceholder);
                }), param.title),
          frame: PromisedValue$SmartcutsMacros.getResolvedExn((function (pendingPlaceholder) {
                  return "for frame w/placeholder" + PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.stringify(pendingPlaceholder);
                }), param.frame),
          windowGeometry: PromisedValue$SmartcutsMacros.getResolvedExn((function (pendingPlaceholder) {
                  return "for windowGeometry w/placeholder" + PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.stringify(pendingPlaceholder);
                }), param.windowGeometry),
          targetBoundingRect: param.targetBoundingRect,
          timestamp: param.timestamp,
          htmlSnapshot: param.htmlSnapshot,
          screenshot: tmp,
          croppedScreenshot: param.croppedScreenshot,
          preconditions: param.preconditions,
          maybeLogoutLocator: param.maybeLogoutLocator
        };
}

function minify$1(context) {
  return {
          windowRef: context.windowRef,
          tabRef: context.tabRef,
          url: context.url,
          focusStatus: context.focusStatus,
          title: context.title,
          frame: context.frame,
          windowGeometry: context.windowGeometry,
          targetBoundingRect: context.targetBoundingRect,
          timestamp: context.timestamp,
          htmlSnapshot: context.htmlSnapshot,
          screenshot: Screenshot$SmartcutsMacros.minify(context.screenshot),
          croppedScreenshot: Screenshot$SmartcutsMacros.minify(context.croppedScreenshot),
          preconditions: context.preconditions,
          maybeLogoutLocator: context.maybeLogoutLocator
        };
}

function rehydrate(context) {
  return Promise.all([
                Storage__Images$SmartcutsMacros.rehydrateScreenshot(context.screenshot),
                Storage__Images$SmartcutsMacros.rehydrateScreenshot(context.croppedScreenshot)
              ]).then(function (param) {
              return Promise.resolve({
                          windowRef: context.windowRef,
                          tabRef: context.tabRef,
                          url: context.url,
                          focusStatus: context.focusStatus,
                          title: context.title,
                          frame: context.frame,
                          windowGeometry: context.windowGeometry,
                          targetBoundingRect: context.targetBoundingRect,
                          timestamp: context.timestamp,
                          htmlSnapshot: context.htmlSnapshot,
                          screenshot: param[0],
                          croppedScreenshot: param[1],
                          preconditions: context.preconditions,
                          maybeLogoutLocator: context.maybeLogoutLocator
                        });
            });
}

function factorOutDynamicVars(commandContext) {
  var screenshot = commandContext.screenshot;
  var targetBoundingRect = commandContext.targetBoundingRect;
  var tmp;
  if (typeof screenshot === "number") {
    tmp = /* NoImage */0;
  } else {
    switch (screenshot.TAG | 0) {
      case /* Image */0 :
          tmp = {
            TAG: /* Image */0,
            _0: Image$SmartcutsMacros.makeIdFromString(""),
            _1: screenshot._1
          };
          break;
      case /* SavingToCloud */1 :
          tmp = {
            TAG: /* SavingToCloud */1,
            _0: Image$SmartcutsMacros.makeIdFromString(""),
            _1: screenshot._1
          };
          break;
      case /* Cloud */2 :
          tmp = {
            TAG: /* Cloud */2,
            _0: Image$SmartcutsMacros.makeIdFromString(""),
            _1: screenshot._1
          };
          break;
      
    }
  }
  return {
          vars: [
            commandContext.timestamp,
            typeof screenshot === "number" ? "" : Image$SmartcutsMacros.idAsString(screenshot._0),
            OptionUtils$SmartcutsMacros.withDefault(0, OptionUtils$SmartcutsMacros.map(targetBoundingRect, (function (r) {
                        return r.x;
                      }))),
            OptionUtils$SmartcutsMacros.withDefault(0, OptionUtils$SmartcutsMacros.map(targetBoundingRect, (function (r) {
                        return r.y;
                      }))),
            OptionUtils$SmartcutsMacros.withDefault(0, OptionUtils$SmartcutsMacros.map(targetBoundingRect, (function (r) {
                        return r.width;
                      }))),
            OptionUtils$SmartcutsMacros.withDefault(0, OptionUtils$SmartcutsMacros.map(targetBoundingRect, (function (r) {
                        return r.height;
                      })))
          ],
          factoredValue: {
            windowRef: commandContext.windowRef,
            tabRef: commandContext.tabRef,
            url: commandContext.url,
            focusStatus: commandContext.focusStatus,
            title: commandContext.title,
            frame: commandContext.frame,
            windowGeometry: commandContext.windowGeometry,
            targetBoundingRect: OptionUtils$SmartcutsMacros.map(targetBoundingRect, (function (_r) {
                    return {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                          };
                  })),
            timestamp: 0,
            htmlSnapshot: commandContext.htmlSnapshot,
            screenshot: tmp,
            croppedScreenshot: commandContext.croppedScreenshot,
            preconditions: commandContext.preconditions,
            maybeLogoutLocator: commandContext.maybeLogoutLocator
          }
        };
}

function substituteInDynamicVars(param) {
  var factoredValue = param.factoredValue;
  var vars = param.vars;
  var arg = Js_json.decodeNumber(Caml_array.get(vars, 0));
  var timestamp = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expected timestamp to be a number");
  var arg$1 = Js_json.decodeString(Caml_array.get(vars, 1));
  var screenshotId = Image$SmartcutsMacros.makeIdFromString((function (param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
          })("Expected screenshotId to be a string"));
  var arg$2 = Js_json.decodeNumber(Caml_array.get(vars, 2));
  var targetBoundingRect_x = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
      })("Expected targetBoundingRect x to be a number");
  var arg$3 = Js_json.decodeNumber(Caml_array.get(vars, 3));
  var targetBoundingRect_y = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$3);
      })("Expected targetBoundingRect y to be a number");
  var arg$4 = Js_json.decodeNumber(Caml_array.get(vars, 4));
  var targetBoundingRect_width = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$4);
      })("Expected targetBoundingRect width to be a number");
  var arg$5 = Js_json.decodeNumber(Caml_array.get(vars, 5));
  var targetBoundingRect_height = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$5);
      })("Expected targetBoundingRect height to be a number");
  var match = factoredValue.screenshot;
  var tmp;
  if (typeof match === "number") {
    tmp = /* NoImage */0;
  } else {
    switch (match.TAG | 0) {
      case /* Image */0 :
          tmp = {
            TAG: /* Image */0,
            _0: screenshotId,
            _1: match._1
          };
          break;
      case /* SavingToCloud */1 :
          tmp = {
            TAG: /* SavingToCloud */1,
            _0: screenshotId,
            _1: match._1
          };
          break;
      case /* Cloud */2 :
          tmp = {
            TAG: /* Cloud */2,
            _0: screenshotId,
            _1: match._1
          };
          break;
      
    }
  }
  return {
          windowRef: factoredValue.windowRef,
          tabRef: factoredValue.tabRef,
          url: factoredValue.url,
          focusStatus: factoredValue.focusStatus,
          title: factoredValue.title,
          frame: factoredValue.frame,
          windowGeometry: factoredValue.windowGeometry,
          targetBoundingRect: OptionUtils$SmartcutsMacros.map(factoredValue.targetBoundingRect, (function (_r) {
                  return {
                          x: targetBoundingRect_x,
                          y: targetBoundingRect_y,
                          width: targetBoundingRect_width,
                          height: targetBoundingRect_height
                        };
                })),
          timestamp: timestamp,
          htmlSnapshot: factoredValue.htmlSnapshot,
          screenshot: tmp,
          croppedScreenshot: factoredValue.croppedScreenshot,
          preconditions: factoredValue.preconditions,
          maybeLogoutLocator: factoredValue.maybeLogoutLocator
        };
}

var Pack = {
  factorOutDynamicVars: factorOutDynamicVars,
  substituteInDynamicVars: substituteInDynamicVars
};

var CommandContextGlobalResolved = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify,
  fromCommandContextGlobalPromised: fromCommandContextGlobalPromised,
  minify: minify$1,
  rehydrate: rehydrate,
  Pack: Pack
};

exports.ContextDependentDevicePixelRatio = ContextDependentDevicePixelRatio;
exports.windowGeometry_encode = windowGeometry_encode;
exports.windowGeometry_decode = windowGeometry_decode;
exports.frame_encode = frame_encode;
exports.frame_decode = frame_decode;
exports.focusStatus_encode = focusStatus_encode;
exports.focusStatus_decode = focusStatus_decode;
exports.stringifyFocusStatus = stringifyFocusStatus;
exports.commandContextLocal_encode = commandContextLocal_encode;
exports.commandContextLocal_decode = commandContextLocal_decode;
exports.associatedElementBoundingRectFromTargetDomEvent = associatedElementBoundingRectFromTargetDomEvent;
exports.targetBoundingRectFromDomElement = targetBoundingRectFromDomElement;
exports.CommandContextGlobalPromised = CommandContextGlobalPromised;
exports.CommandContextGlobalResolved = CommandContextGlobalResolved;
/* Rect-SmartcutsMacros Not a pure module */
